<div class="px-3" data-cy="BASKET_ADDRESS_DIALOG">
  <div class="row mb-3">
    <div class="col">
      <h2>
        <em class="fas fa-map-marked-alt pe-2"></em>
        @if (!addressForm) {
          <span>{{ 'Adresse wählen' | translate }}</span>
        }
        @if (addressForm) {
          <span>{{ 'Adresse' | translate }}</span>
        }
      </h2>
    </div>
    <div class="col-auto">
      <em class="fas fa-times fa-1_5x text-danger cursor-pointer" (click)="cancel()"></em>
    </div>
  </div>
  @if (!addressForm && !contactForm) {
    <div class="row justify-content-end">
      <div class="col-auto">
        @if (isDelivery) {
          <div class="btn-group btn-group-sm">
            @if (options.isEditable) {
              <button class="btn btn-outline-dark btn-small" (click)="freeEdit()">
                <em class="fas fa-map-location-dot"></em>
                {{ 'freie Adresseingabe' | translate }}
              </button>
              @if (options.currentAddress) {
                <button
                  class="btn btn-outline-dark btn-small"
                  (click)="freeEdit(options.currentAddress)"
                  >
                  <em class="fas fa-pen"></em>
                  {{ 'aktuelle bearbeiten' | translate }}
                </button>
              }
            }
            <!--
              EPROC-11920: eigener Button für den eigenen Schalter. Er ändert nur den
              Ansprechpartner und behält die Lieferadress-ID, deshalb steht er neben
              „aktuelle bearbeiten" statt darin.
            -->
            @if (options.isContactEditable && options.currentAddress) {
              <button
                class="btn btn-outline-dark btn-small"
                data-cy="BASKET_DELIVERY_CONTACT_EDIT"
                (click)="contactEdit(options.currentAddress)"
                >
                <em class="fas fa-user-pen"></em>
                {{ 'aktuellen Ansprechpartner bearbeiten' | translate }}
              </button>
            }
          </div>
        }
      </div>
    </div>
    <div class="row">
      <div class="col text-description">
        <div class="row align-items-center">
          <div class="col-auto">
            <span class="font-11">{{ 'Alle Adressen' | translate }}</span>
          </div>
          <div class="col">
            <hr />
          </div>
        </div>
      </div>
    </div>
    <div class="row mb-1">
      <div class="col">
        <input
          class="form-control"
          [placeholder]="addressSearchPlaceholder | translate"
          [formControl]="addressSearchCtrl"
          />
      </div>
    </div>
    @if (filteredAddresses) {
      <div class="mb-2">
        <ul class="list-group">
          @for (address of filteredAddresses; track address) {
            <li class="list-group-item" data-cy="BASKET_DELIVERY_ADDRESS_ITEM">
              <div class="row mb-1 align-items-center">
                <div class="col-xl-8 col-lg-4 col-md-4 col-sm-6 col-12">
                  <address [highlight]="addressSearchCtrl.value" [address]="address"></address>
                  @if (address.sources; as sources) {
                    @if (sources.length) {
                      <span class="badge bg-info text-dark mt-1">
                        @if (sources.includes('SITE') && sources.includes('USER')) {
                          {{ 'Standort + Persönlich' | translate }}
                        } @else if (sources.includes('SITE')) {
                          {{ 'Standort-Adresse' | translate }}
                        } @else {
                          {{ 'Meine Adresse' | translate }}
                        }
                      </span>
                    }
                  }
                </div>
                <div class="col-xl-4 col-lg-8 col-md-8 col-sm-6 col-12 d-flex justify-content-end">
                  @if (isDelivery && options.isEditable) {
                    <button
                      class="btn btn-outline-dark btn-sm me-1"
                      (click)="freeEdit(address)"
                      >
                      {{ 'Bearbeiten' | translate }}
                      <em class="fas fa-pen"></em>
                    </button>
                  }
                  <button class="btn btn-primary btn-sm" (click)="save(address)">
                    {{ 'übernehmen' | translate }}
                    <em class="fas fa-arrow-right"></em>
                  </button>
                </div>
              </div>
            </li>
          }
        </ul>
      </div>
    }
    <div class="row justify-content-end">
      <div class="col-md-auto col-sm-12 mb-1">
        <button class="btn btn-outline-dark btn-sm w-100" (click)="cancel()">
          {{ 'Abbrechen' | translate }}
        </button>
      </div>
    </div>
  }
  @if (addressForm) {
    <div class="col">
      <form
        class="h-100"
        [formGroup]="addressForm"
        (submit)="$event.preventDefault(); $event.stopImmediatePropagation(); $event.stopPropagation()"
        >
        <div class="row">
          <div class="col text-description px-0">
            <div class="row align-items-center">
              <div class="col-auto">
                <span class="font-11">{{ 'Adressat' | translate }}</span>
              </div>
              <div class="col">
                <hr />
              </div>
            </div>
          </div>
        </div>
        <div class="row mb-2 align-items-center">
          <div class="col-lg-3 col-md-4 col-sm-12 px-0">
            <strong>{{ 'Vorname' | translate }}</strong>
          </div>
          <div class="col">
            <input
              class="form-control w-100"
              [placeholder]="'Vorname' | translate"
              formControlName="firstName"
              />
          </div>
        </div>
        <div class="row mb-2 align-items-center">
          <div class="col-lg-3 col-md-4 col-sm-12 px-0">
            <strong>{{ 'Nachname' | translate }}</strong>
          </div>
          <div class="col">
            <input
              class="form-control w-100"
              [placeholder]="'Nachname' | translate"
              formControlName="lastName"
              />
          </div>
        </div>
        <div class="row">
          <div class="col text-description px-0">
            <div class="row align-items-center">
              <div class="col-auto">
                <span class="font-11">{{ 'Name der Firma' | translate }}</span>
              </div>
              <div class="col">
                <hr />
              </div>
            </div>
          </div>
        </div>
        <div class="row mb-2 align-items-center">
          <div class="col-lg-3 col-md-4 col-sm-12 px-0">
            <strong>{{ 'Zeile 1' | translate }}</strong>
          </div>
          <div class="col">
            <input
              class="form-control w-100"
              [placeholder]="'Firmenname' | translate"
              formControlName="companyName"
              mark-required
              />
          </div>
        </div>
        <div class="row mb-2 align-items-center">
          <div class="col-lg-3 col-md-4 col-sm-12 px-0">
            <strong>{{ 'Zeile 2' | translate }}</strong>
          </div>
          <div class="col">
            <input
              class="form-control w-100"
              [placeholder]="'Firmenname 2' | translate"
              formControlName="companyName2"
              />
          </div>
        </div>
        <div class="row">
          <div class="col text-description px-0">
            <div class="row align-items-center">
              <div class="col-auto">
                <span class="font-11">{{ 'Adresse' | translate }}</span>
              </div>
              <div class="col">
                <hr />
              </div>
            </div>
          </div>
        </div>
        <div class="row mb-2 align-items-center">
          <div class="col-lg-3 col-md-4 col-sm-12 px-0">
            <label>
              <strong>{{ 'Straße' | translate }}</strong>
            </label>
          </div>
          <div class="col">
            <input
              class="form-control w-100"
              [placeholder]="'Straße' | translate"
              formControlName="street"
              mark-required
              />
          </div>
        </div>
        <div class="row mb-2 align-items-center">
          <div class="col-lg-3 col-md-4 col-sm-12 px-0">
            <label>
              <strong>{{ 'Postleitzahl' | translate }}</strong>
            </label>
          </div>
          <div class="col">
            <input
              class="form-control w-100"
              [placeholder]="'Postleitzahl' | translate"
              formControlName="zip"
              mark-required
              />
          </div>
        </div>
        @if (addressForm.controls['zip'].hasError('pattern')) {
          <div class="row mb-2">
            <div class="col">
              <div class="alert alert-danger mb-0 p-2">
                {{ 'Postleitzahlen dürfen nur Zahlen enthalten' | translate }}
              </div>
            </div>
          </div>
        }
        @if (addressForm.controls['zip'].errors?.maxlength) {
          <div class="row mb-2">
            <div class="col">
              <div class="alert alert-danger mb-0 p-2">
                {{ 'Maximal 10 Zeichen erlaubt' | translate }}
              </div>
            </div>
          </div>
        }
        <div class="row mb-2 align-items-center">
          <div class="col-lg-3 col-md-4 col-sm-12 px-0">
            <label>
              <strong>{{ 'Stadt' | translate }}</strong>
            </label>
          </div>
          <div class="col">
            <input
              class="form-control w-100"
              [placeholder]="'Stadt' | translate"
              formControlName="city"
              mark-required
              />
          </div>
        </div>
        <div class="row mb-2 align-items-center">
          <div class="col-lg-3 col-md-4 col-sm-12 px-0">
            <strong>{{ 'Bundesland' | translate }}</strong>
          </div>
          <div class="col">
            <input
              class="form-control w-100"
              [placeholder]="'Bundesland' | translate"
              formControlName="country"
              />
          </div>
        </div>
        <div class="row justify-content-end">
          <div class="col-auto">
            <div class="btn-group">
              <button type="button" class="btn btn-secondary btn-sm" (click)="addressForm = undefined">
                <em class="fas fa-arrow-left"></em>
                {{ 'zurück' | translate }}
              </button>
              <button
                class="btn btn-primary btn-sm"
                type="submit"
                [disabled]="addressForm.invalid"
                (click)="saveFreeEdit()"
                >
                <em class="fas fa-floppy-disk"></em>
                {{ 'übernehmen' | translate }}
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  }
  <!--
    EPROC-11920: Ansprechpartner-Modus. Die Adresse steht zur Kontrolle als reine Ausgabe da, ohne
    Eingabefelder — dieser Weg ändert ausschließlich den Namen, damit die Lieferadresse mit ihrem
    Standortbezug (und damit ihrer ID) verknüpft bleibt.
  -->
  @if (contactForm && contactAddress) {
    <div class="col">
      <form
        class="h-100"
        [formGroup]="contactForm"
        (submit)="$event.preventDefault(); $event.stopImmediatePropagation(); $event.stopPropagation()"
        >
        <div class="row">
          <div class="col text-description px-0">
            <div class="row align-items-center">
              <div class="col-auto">
                <span class="font-11">{{ 'Ansprechpartner' | translate }}</span>
              </div>
              <div class="col">
                <hr />
              </div>
            </div>
          </div>
        </div>
        @if (contactCandidatesLoading()) {
          <div class="row mb-2">
            <div class="col d-flex align-items-center text-description">
              <em class="fas fa-spinner fa-spin me-2"></em>
              {{ 'Mitarbeiter werden geladen' | translate }}
            </div>
          </div>
        } @else if (contactCandidatesFailed()) {
          <div class="row mb-2">
            <div class="col">
              <div class="alert alert-warning mb-0 p-2">
                {{ 'Mitarbeiter konnten nicht geladen werden.' | translate }}
              </div>
            </div>
          </div>
        } @else {
          <div class="row mb-2 align-items-center">
            <div class="col-lg-3 col-md-4 col-sm-12 px-0">
              <strong>{{ 'Mitarbeiter' | translate }}</strong>
            </div>
            <div class="col">
              <iim-advanced-autocomplete
                [showLabel]="false"
                [placeholder]="'Mitarbeiter suchen' | translate"
                (valueSelected)="onContactCandidateSelected($event)"
                dataCyPrefix="BASKET_DELIVERY_CONTACT_AUTOCOMPLETE"
              >
                <!-- The narrow candidate DTO carries no id, and two colleagues may share a name. -->
                @for (option of contactCandidates(); track $index) {
                  <iim-autocomplete-option [value]="option">{{ option.valueDisplay }}</iim-autocomplete-option>
                }
              </iim-advanced-autocomplete>
              <small class="text-muted">
                {{ 'optional: Mitarbeiter auswählen füllt die Felder aus' | translate }}
              </small>
            </div>
          </div>
        }
        <div class="row mb-2 align-items-center">
          <div class="col-lg-3 col-md-4 col-sm-12 px-0">
            <strong>{{ 'Vorname' | translate }}</strong>
          </div>
          <div class="col">
            <input
              class="form-control w-100"
              data-cy="BASKET_DELIVERY_CONTACT_FIRSTNAME"
              [placeholder]="'Vorname' | translate"
              formControlName="firstName"
              />
          </div>
        </div>
        <div class="row mb-2 align-items-center">
          <div class="col-lg-3 col-md-4 col-sm-12 px-0">
            <strong>{{ 'Nachname' | translate }}</strong>
          </div>
          <div class="col">
            <input
              class="form-control w-100"
              data-cy="BASKET_DELIVERY_CONTACT_LASTNAME"
              [placeholder]="'Nachname' | translate"
              formControlName="lastName"
              />
          </div>
        </div>
        @if (contactForm.controls['firstName'].errors?.maxlength || contactForm.controls['lastName'].errors?.maxlength) {
          <div class="row mb-2">
            <div class="col">
              <div class="alert alert-danger mb-0 p-2">
                {{ 'Maximal 40 Zeichen erlaubt' | translate }}
              </div>
            </div>
          </div>
        }
        <div class="row">
          <div class="col text-description px-0">
            <div class="row align-items-center">
              <div class="col-auto">
                <span class="font-11">{{ 'Adresse (nicht änderbar)' | translate }}</span>
              </div>
              <div class="col">
                <hr />
              </div>
            </div>
          </div>
        </div>
        <!--
          The offset keeps the read-only address in the same column as the input fields above it;
          showContact is off because the contact person is the editable field above (EPROC-11920).
        -->
        <div class="row mb-3">
          <div class="col-lg-9 offset-lg-3 col-md-8 offset-md-4 col-sm-12">
            <address
              data-cy="BASKET_DELIVERY_CONTACT_ADDRESS"
              [address]="contactAddress"
              [showContact]="false"
            ></address>
          </div>
        </div>
        <div class="row justify-content-end">
          <div class="col-auto">
            <div class="btn-group">
              <button type="button" class="btn btn-secondary btn-sm" (click)="closeContactEdit()">
                <em class="fas fa-arrow-left"></em>
                {{ 'zurück' | translate }}
              </button>
              <button
                class="btn btn-primary btn-sm"
                type="submit"
                data-cy="BASKET_DELIVERY_CONTACT_SAVE"
                [disabled]="contactForm.invalid"
                (click)="saveContactEdit()"
                >
                <em class="fas fa-floppy-disk"></em>
                {{ 'übernehmen' | translate }}
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  }
</div>
